import { gql } from '@apollo/client'
import { USER_FIELDS, COMPANY_FIELDS } from '../fragments'

export const BROADSIGN_CREATIONS = gql`
  ${USER_FIELDS}
  ${COMPANY_FIELDS}
  query BroadsignCreations(
    $filters: BroadsignCreationFilters
    $first: Int
    $last: Int
    $sortColumn: BroadsignCreationsSortColumnEnum
    $sortDirection: SortDirectionEnum
  ) {
    broadsignCreations(
      filters: $filters
      first: $first
      last: $last
      sortColumn: $sortColumn
      sortDirection: $sortDirection
    ) {
      nodes {
        id
        broadsignId
        mediaFormat
        createdAt
        frameFormat
        duration
        status
        width
        height
        details
        usedBuildingsNotSentCount
        file {
          filename
          url
          isVideo
          mimeType
        }
        thumbnailUrl
        advertiser {
          ...CompanyFields
        }
        commercialSupervisor {
          ...UserFields
        }
        department {
          id
          name
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`
